<script>
    import app from "../lib/stores/app.js";
    import department$ from "../lib/stores/department$.js";
    import location$ from "../lib/stores/location$.js";
    import {LOCATION_TYPE, ROUTE_TITLES, SUMMARY_TITLES, ROUTE_TYPE} from "../lib/js/constants.js";
    import {addToDate, fnt, hasBoatName, hasFlightNo, hasRoomNo, HM, YMD} from "../lib/js/utils.js";
    import LocationControl from "../lib/controls/LocationControl.svelte";
    import DateControl from "../lib/controls/DateControl.svelte";
    import TimeControl from "../lib/controls/TimeControl.svelte";
    import Icon from "../lib/components/icons/Icon.svelte";
    import StrictLocationControl from "../lib/controls/StrictLocationControl.svelte";
    import ReservationPassengers from "../book/ReservationPassengers.svelte";


    export let reservation;

    export let onNext = fnt();

    let startDate = '';
    let date_at = null;
    let time_at = null;
    // let arrival_time_at = null;
    let showFlightNo = false;
    let showBoatName = false;
    let initialized = false;

    let pickups = [];
    let destinations = [];
    let rest_locations = [];

    let route;
    let route_type = '';

    const removeFromArray = (original, to_remove) => {
        const idsToRemove = new Set(to_remove.map(item => item.id));
        return original.filter(item => !idsToRemove.has(item.id));
    }

    const initialize = () => {
        route = reservation.routes[0];

        const start_day = addToDate(new Date(), 1);
        startDate = YMD(start_day);

        if (!route.transfer_at) {
            date_at = YMD(start_day);
            const current_time = HM(start_day);
            // get rounded minutes for time
            let [hour, min] = current_time.split(":");
            time_at = `${hour}:${min[0]}0`;
        } else {
            date_at = YMD(route.transfer_at);
            time_at = HM(route.transfer_at);
        }

        // get start locations (airports, ports)
        let starts = $location$.list.filter(x => x.is_start_point == 1);

        // get locations that are hotels in department;
        let hotels = [];
        $department$.hotels.map(hotel => {
            let location = $location$.list.find(x => x.hotel_id == hotel.id);
            if (location) {
                hotels.push(location);
            }
        });

        reservation.title = SUMMARY_TITLES[$app.reservation_type]

        if ($app.reservation_type === 'arrival') {

            // From airport to hotel
            pickups = starts;
            destinations = hotels;

            route.route_type = ROUTE_TYPE.ARRIVAL;
            if (!route._pickup) {
                route._pickup = pickups[0];
            }

        } else if ($app.reservation_type === 'departure') {

            // From hotel to airport
            pickups = hotels;
            destinations = starts;

            route.route_type = ROUTE_TYPE.DEPARTURE;
            if (!route._drop) {
                route._drop = destinations[0];
            }

        } else if ($app.reservation_type === 'hotel') {

            // From hotel to anywhere
            pickups = hotels;
            rest_locations = removeFromArray($location$.list, pickups);

            route.route_type = ROUTE_TYPE.TRANSFER;

        } else if ($app.reservation_type === 'location') {

            // From anywhere to hotel
            destinations = hotels;
            rest_locations = removeFromArray($location$.list, destinations);

            route.route_type = ROUTE_TYPE.TRANSFER;

        }

        initialized = true;
    }

    const onPickupChange = ({detail}) => {
        route._pickup = detail;
    }

    const onDestinationChange = ({detail}) => {
        route._drop = detail;
    }


    const submit = (event) => {
        event.preventDefault();
        event.stopPropagation();

        route.transfer_at = `${date_at} ${time_at}`;

        reservation.routes[0] = route;

        onNext();
    }

    initialize();

    $: reservation.passengers = reservation.adults + reservation.children + reservation.infants;

    $: if (reservation.infants > reservation.infant_seats) {
        reservation.infant_seats = reservation.infants;
    }

    $: {
        showFlightNo = hasFlightNo(route._pickup, route._drop);
        showBoatName = hasBoatName(route._pickup, route._drop);

        if (!showFlightNo && !showBoatName) {
            route.flight_no = '';
        }
    }
</script>

{#if initialized}
    <div class="section-title mb-4">
        <h2 class="h4 mb-0">{reservation.title}</h2>
        <div>Please provide your pickup details below</div>
    </div>

    <form autocomplete="off" on:submit={submit}>
        <div class="mb-4">
            <div class="row">
                {#if $app.reservation_type === 'arrival'}

                    <div class="col-md-4 mb-3">
                        <label>Airport or Port</label>
                        <StrictLocationControl bind:location={route._pickup} locations={pickups}
                                               on:change={onPickupChange} required/>
                    </div>
                    <div class="col-md-4 mb-3">
                        <label>Your hotel</label>
                        <StrictLocationControl bind:location={route._drop} locations={destinations}
                                               placeholder="... select your hotel ..."
                                               on:change={onDestinationChange} required/>
                    </div>

                {:else if $app.reservation_type === 'departure'}

                    <div class="col-md-4 mb-3">
                        <label>Your hotel</label>
                        <StrictLocationControl bind:location={route._pickup} locations={pickups}
                                               placeholder="... select your hotel ..."
                                               on:change={onPickupChange} required/>
                    </div>
                    <div class="col-md-4 mb-3">
                        <label>Airport or Port</label>
                        <StrictLocationControl bind:location={route._drop} locations={destinations}
                                               on:change={onDestinationChange} required/>
                    </div>

                {:else if $app.reservation_type === 'hotel'}

                    <div class="col-md-4 mb-3">
                        <label>Your hotel</label>
                        <StrictLocationControl bind:location={route._pickup} locations={pickups}
                                               placeholder="... select your hotel ..."
                                               on:change={onPickupChange} required/>
                    </div>
                    <div class="col-md-4 mb-3">
                        <label>Destination</label>
                        <LocationControl default_locations={rest_locations} all_locations={rest_locations}
                                         bind:location={route._drop}
                                         on:change={onDestinationChange}
                                         placeholder="select destination" required/>
                        {#if route._drop && route._drop.type_id == LOCATION_TYPE.DEFAULT}
                            <div class="mt-1">
                                <input type="text" class="form-control" bind:value={route._drop.address} placeholder="destination address">
                            </div>
                        {/if}
                    </div>

                {:else}

                    <div class="col-md-4 mb-3">
                        <label>Pickup from</label>
                        <LocationControl default_locations={rest_locations} all_locations={rest_locations}
                                         bind:location={route._pickup}
                                         on:change={onPickupChange}
                                         placeholder="select pickup location" required/>
                        {#if route._pickup && route._pickup.type_id == LOCATION_TYPE.DEFAULT}
                            <div class="mt-1">
                                <input type="text" class="form-control" bind:value={route._pickup.address} placeholder="pickup address">
                            </div>
                        {/if}
                    </div>
                    <div class="col-md-4 mb-3">
                        <label>Your hotel</label>
                        <StrictLocationControl bind:location={route._drop} locations={destinations}
                                               placeholder="... select your hotel ..."
                                               on:change={onDestinationChange} required/>
                    </div>

                {/if}
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-8 col-6 mb-3">
                            <label>Date</label>
                            <DateControl bind:value={date_at} {startDate} hideToday hideClear/>
                        </div>
                        <div class="col-md-4 col-6 mb-3">
                            <label>Time</label>
                            <TimeControl id="date_at" bind:value={time_at} required/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                {#if showFlightNo}
                    <div class="col-md-4 col-6 mb-3">
                        <label>Flight number</label>
                        <input type="text" class="form-control" bind:value={route.flight_no} required>
                    </div>
                {/if}
                {#if showBoatName}
                    <div class="col-md-4 col-6 mb-3">
                        <label>Ferry (if applicable)</label>
                        <input type="text" class="form-control" bind:value={route.flight_no}>
                    </div>
                {/if}
            </div>

            <ReservationPassengers bind:reservation/>
        </div>

        <p class="mb-4">All transfers are private and include complimentary bottled water and Wi-Fi.</p>

        <div class="row">
            <div class="col-md-9 hidden-sm hidden-xs">
            </div>
            <div class="col-md-3 col-12">
                <button type="submit"
                        class="btn btn-primary d-flex align-items-center justify-content-center gap-1 w-100 px-0 py-3">
                    Continue to Vehicle Selection
                    <span class="btn-icon"><Icon name="chevron-right" size="16"/></span>
                </button>
            </div>
        </div>
    </form>
{/if}

